import { cleanupFeatures } from "./cleanup"
import { getPolygons, MinimumZoneArea } from "./polygons"
import { IMapTopologyService } from "./topo/types"
import { ol_Feature, ol_geom } from "@omnia/exports/openlayers";

export function insertNewGeometry<Zone extends { feature: ol_Feature }>(
    geometry: ol_geom.Geometry,
    layer: { zones: Zone[] },
    topo: IMapTopologyService,
    createNewZone: (geometry: ol_geom.Geometry, initialZone?: Zone) => void,
    removeZone: (zone: Zone) => void,
    splitOnExistingZones: boolean,
    minimumArea: number = MinimumZoneArea
) {

    if (!geometry) return false

    const zones = layer.zones
        .map(z => ({
            zone: z,
            geom: z.feature.getGeometry()
        }))
        .filter(z => !topo.disjoint(geometry, z.geom))
        .map(z => ({
            ...z,
            diff: topo.difference(z.geom, [geometry])
        }))
        .map(z => ({
            ...z,
            parts: getPolygons(z.diff.getOpenLayersGeometry(), minimumArea)
        }))
        .map(z => ({
            ...z,
            remove: z.parts.length < 1
        }))


    zones.filter(z => z.remove).forEach(z => removeZone(z.zone))

    zones.filter(z => !z.remove).forEach(z => {

        z.zone.feature.setGeometry(z.parts[0])

        z.parts.slice(1).forEach(s => createNewZone(s, z.zone))

    })

    if (!splitOnExistingZones) {

        createNewZone(geometry)

    }
    else {

        zones
            .filter(z => !z.remove)
            .map(z => ({
                ...z,
                parts: getPolygons(topo.intersection(z.geom, geometry).getOpenLayersGeometry())
            }))
            .forEach(z => {
                z.parts.forEach(p => createNewZone(p))
            })

    }

    cleanupFeatures(layer.zones.map(z => z.feature))

    return true

}
